import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";

import { FONT_SECONDARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import Cart from "@/components/Header/Cart";

const HeaderButtons = () => {
  const isMobileNav = useResponsive("down", "lg");
  const isLargeDesktop = useResponsive("up", "xl");

  return (
    <Box
      sx={{ flexGrow: 0 }}
      display="flex"
      flexDirection={isMobileNav ? "column-reverse" : "row"}
      gap={!isLargeDesktop ? 1 : 3}
    >
      {!isMobileNav && <Cart />}

      {isMobileNav && (
        <Button
          component={Link}
          to={ROUTES.legacyLogin}
          variant="outlined"
          color="secondary"
          size="large"
          aria-controls="user-log-in"
          disableElevation
          fullWidth
          sx={{ fontFamily: FONT_SECONDARY, display: "flex" }}
        >
          Log in
        </Button>
      )}

      <Button
        component={Link}
        to={ROUTES.legacySignUp}
        aria-controls="activate-tracker"
        variant="text"
        sx={{ 
          minWidth: "fit-content",
          fontFamily: "Mulish",
          fontWeight: 700,
          fontSize: 14,
          lineHeight: "125%",
          letterSpacing: 0,
          textAlign: "right",
          color: "#2C2C2C",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "transparent",
            color: "#2C2C2C",
          },
        }}
      >
        Activate Tracker
      </Button>
    </Box>
  );
};

export default HeaderButtons;
